<template>
    <role-manage-list/>
</template>

<script>
    import RoleManageList from "_private/components/super/systemSetting/roleManage/List";

    export default {
        components: {
            RoleManageList
        }
    };
</script>
